export * from './autoconfirmConfigAPI.service';
import { AutoconfirmConfigAPIService } from './autoconfirmConfigAPI.service';
export * from './configurationAPI.service';
import { ConfigurationAPIService } from './configurationAPI.service';
export * from './exportAPI.service';
import { ExportAPIService } from './exportAPI.service';
export * from './priceEngineAPI.service';
import { PriceEngineAPIService } from './priceEngineAPI.service';
export * from './revenueManagerAPI.service';
import { RevenueManagerAPIService } from './revenueManagerAPI.service';
export const APIS = [AutoconfirmConfigAPIService, ConfigurationAPIService, ExportAPIService, PriceEngineAPIService, RevenueManagerAPIService];
